var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "productivity-tracking matrix-ui paginated"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "is-full-screen": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "global-filter-bar"
  }, [_c('div', {
    staticClass: "left-section"
  }, [_c('div', {
    staticClass: "title-wrap"
  }, [_c('h1', [_vm._v("Work Performance "), _c('small', [_vm._v(_vm._s(_vm.hubName))])]), _vm._v(" "), _c('div', {
    staticClass: "global-toggle"
  }, [_c('button', {
    class: {
      active: _vm.globalViewMode === 'performance'
    },
    on: {
      "click": function($event) {
        _vm.globalViewMode = 'performance'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Performance\n            ")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.globalViewMode === 'rayg'
    },
    on: {
      "click": function($event) {
        _vm.globalViewMode = 'rayg'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th"
  }), _vm._v(" RAYG Grid\n            ")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.globalViewMode === 'hubAnalytics'
    },
    on: {
      "click": function($event) {
        _vm.globalViewMode = 'hubAnalytics'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" Hub Analytics\n            ")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.globalViewMode === 'geographic'
    },
    on: {
      "click": function($event) {
        _vm.globalViewMode = 'geographic'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Geographic\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-section"
  }, [(_vm.globalViewMode === 'performance') ? _c('div', {
    staticClass: "filter-group"
  }, [_c('div', {
    staticClass: "filter-item date-item"
  }, [_c('label', [_vm._v("Working Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "format": "DD-MM-YYYY",
      "type": "date",
      "placeholder": "Select Date"
    },
    model: {
      value: (_vm.perfFilters.date),
      callback: function($$v) {
        _vm.$set(_vm.perfFilters, "date", $$v)
      },
      expression: "perfFilters.date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-item period-item"
  }, [_c('label', [_vm._v("Reporting Period")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perfFilters.days),
      expression: "perfFilters.days"
    }],
    staticClass: "period-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.perfFilters, "days", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Day View")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 7
    }
  }, [_vm._v("Last 7 Days")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("Last 15 Days")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 30
    }
  }, [_vm._v("Last 1 Month")])])]), _vm._v(" "), _c('div', {
    staticClass: "filter-item type-item"
  }, [_c('label', [_vm._v("Emp Type")]), _vm._v(" "), _c('div', {
    staticClass: "custom-multiselect"
  }, [_c('div', {
    staticClass: "select-trigger",
    on: {
      "click": function($event) {
        return _vm.toggleTypeDropdown($event)
      }
    }
  }, [(_vm.perfFilters.selectedTypes.length === 0) ? _c('span', {
    staticClass: "placeholder"
  }, [_vm._v("All Types")]) : _c('span', {
    staticClass: "selected-tokens",
    attrs: {
      "title": _vm.perfFilters.selectedTypes.join(', ')
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.perfFilters.selectedTypes.join(', ')) + "\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), (_vm.showTypeDropdown) ? _c('div', {
    staticClass: "select-dropdown"
  }, [_vm._l((_vm.availableEmployeeTypes), function(type) {
    return _c('div', {
      key: type,
      staticClass: "dropdown-option",
      on: {
        "click": function($event) {
          return _vm.toggleTypeSelection(type)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.perfFilters.selectedTypes.includes(type)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "type-text"
    }, [_vm._v(_vm._s(type))])])
  }), _vm._v(" "), (_vm.availableEmployeeTypes.length === 0) ? _c('div', {
    staticClass: "no-options"
  }, [_vm._v("\n                  No employee types\n                ")]) : _vm._e()], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "filter-item search-item"
  }, [_c('label', [_vm._v("Emp ID / Name / Email")]), _vm._v(" "), _c('div', {
    staticClass: "input-wrap"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perfFilters.searchId),
      expression: "perfFilters.searchId"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.perfFilters.searchId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.perfFilters, "searchId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-item action-item"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-export",
    on: {
      "click": _vm.exportPerformanceCSV
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export\n            ")])])]) : (_vm.globalViewMode === 'rayg') ? _c('div', {
    staticClass: "filter-group"
  }, [_c('div', {
    staticClass: "filter-item date-item"
  }, [_c('label', [_vm._v("Grid Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "format": "DD-MM-YYYY",
      "type": "date",
      "placeholder": "Select Date"
    },
    model: {
      value: (_vm.raygFilters.date),
      callback: function($$v) {
        _vm.$set(_vm.raygFilters, "date", $$v)
      },
      expression: "raygFilters.date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-item period-item"
  }, [_c('label', [_vm._v("Period Scope")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.raygFilters.days),
      expression: "raygFilters.days"
    }],
    staticClass: "period-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.raygFilters, "days", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Daily View")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 7
    }
  }, [_vm._v("7-Day Trend")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15-Day Trend")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 30
    }
  }, [_vm._v("30-Day Trend")])])]), _vm._v(" "), _c('div', {
    staticClass: "filter-item type-item"
  }, [_c('label', [_vm._v("Emp Type")]), _vm._v(" "), _c('div', {
    staticClass: "custom-multiselect"
  }, [_c('div', {
    staticClass: "select-trigger",
    on: {
      "click": function($event) {
        return _vm.toggleTypeDropdown($event)
      }
    }
  }, [(_vm.raygFilters.selectedTypes.length === 0) ? _c('span', {
    staticClass: "placeholder"
  }, [_vm._v("All Types")]) : _c('span', {
    staticClass: "selected-tokens",
    attrs: {
      "title": _vm.raygFilters.selectedTypes.join(', ')
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.raygFilters.selectedTypes.join(', ')) + "\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), (_vm.showTypeDropdown) ? _c('div', {
    staticClass: "select-dropdown"
  }, [_vm._l((_vm.availableEmployeeTypes), function(type) {
    return _c('div', {
      key: type,
      staticClass: "dropdown-option",
      on: {
        "click": function($event) {
          return _vm.toggleTypeSelection(type)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.raygFilters.selectedTypes.includes(type)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "type-text"
    }, [_vm._v(_vm._s(type))])])
  }), _vm._v(" "), (_vm.availableEmployeeTypes.length === 0) ? _c('div', {
    staticClass: "no-options"
  }, [_vm._v("\n                  No employee types\n                ")]) : _vm._e()], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "filter-item search-item"
  }, [_c('label', [_vm._v("Emp Search")]), _vm._v(" "), _c('div', {
    staticClass: "input-wrap"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.raygFilters.searchId),
      expression: "raygFilters.searchId"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Filter employees..."
    },
    domProps: {
      "value": (_vm.raygFilters.searchId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.raygFilters, "searchId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "filter-item action-item"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-export rayg",
    on: {
      "click": _vm.exportRaygCSV
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Export\n            ")])])]) : (_vm.globalViewMode === 'hubAnalytics') ? _c('div', {
    staticClass: "filter-group"
  }, [_c('div', {
    staticClass: "filter-item date-item"
  }, [_c('label', [_vm._v("Analysis Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "format": "DD-MM-YYYY",
      "type": "date",
      "placeholder": "Select Date"
    },
    model: {
      value: (_vm.hubAnalyticsFilters.date),
      callback: function($$v) {
        _vm.$set(_vm.hubAnalyticsFilters, "date", $$v)
      },
      expression: "hubAnalyticsFilters.date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-item period-item"
  }, [_c('label', [_vm._v("Period")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubAnalyticsFilters.days),
      expression: "hubAnalyticsFilters.days"
    }],
    staticClass: "period-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.hubAnalyticsFilters, "days", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("1 Day")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 7
    }
  }, [_vm._v("7 Days")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15 Days")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 30
    }
  }, [_vm._v("30 Days")])])]), _vm._v(" "), _c('div', {
    staticClass: "filter-item period-item"
  }, [_c('label', [_vm._v("Same weekday")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.hubAnalyticsFilters.compareWeeksAgo),
      expression: "hubAnalyticsFilters.compareWeeksAgo",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "period-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.hubAnalyticsFilters, "compareWeeksAgo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("1 week ago")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("2 weeks ago")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("3 weeks ago")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("4 weeks ago")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5 weeks ago")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 6
    }
  }, [_vm._v("6 weeks ago")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 7
    }
  }, [_vm._v("7 weeks ago")])])]), _vm._v(" "), _c('div', {
    staticClass: "filter-item type-item"
  }, [_c('label', [_vm._v("Emp Type")]), _vm._v(" "), _c('div', {
    staticClass: "custom-multiselect"
  }, [_c('div', {
    staticClass: "select-trigger",
    on: {
      "click": function($event) {
        return _vm.toggleTypeDropdown($event)
      }
    }
  }, [(_vm.hubAnalyticsFilters.selectedTypes.length === 0) ? _c('span', {
    staticClass: "placeholder"
  }, [_vm._v("All Types")]) : _c('span', {
    staticClass: "selected-tokens"
  }, [_vm._v(_vm._s(_vm.hubAnalyticsFilters.selectedTypes.join(', ')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), (_vm.showTypeDropdown) ? _c('div', {
    staticClass: "select-dropdown"
  }, _vm._l((_vm.availableEmployeeTypes), function(type) {
    return _c('div', {
      key: 'hub-' + type,
      staticClass: "dropdown-option",
      on: {
        "click": function($event) {
          return _vm.toggleTypeSelection(type)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.hubAnalyticsFilters.selectedTypes.includes(type)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "type-text"
    }, [_vm._v(_vm._s(type))])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "filter-item type-item"
  }, [_c('label', [_vm._v("Work Area")]), _vm._v(" "), _c('div', {
    staticClass: "custom-multiselect"
  }, [_c('div', {
    staticClass: "select-trigger",
    on: {
      "click": function($event) {
        return _vm.toggleHubCategoryDropdown($event)
      }
    }
  }, [(_vm.hubAnalyticsFilters.selectedCategories.length === 0) ? _c('span', {
    staticClass: "placeholder"
  }, [_vm._v("All Areas")]) : _c('span', {
    staticClass: "selected-tokens",
    attrs: {
      "title": _vm.hubAnalyticsFilters.selectedCategories.join(', ')
    }
  }, [_vm._v(_vm._s(_vm.hubAnalyticsFilters.selectedCategories.join(', ')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), (_vm.showHubCategoryDropdown) ? _c('div', {
    staticClass: "select-dropdown"
  }, [_vm._l((_vm.availableHubCategories), function(cat) {
    return _c('div', {
      key: 'hub-cat-' + cat,
      staticClass: "dropdown-option",
      on: {
        "click": function($event) {
          return _vm.toggleHubCategorySelection(cat)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.hubAnalyticsFilters.selectedCategories.includes(cat)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "type-text"
    }, [_vm._v(_vm._s(cat))])])
  }), _vm._v(" "), (!_vm.availableHubCategories.length) ? _c('div', {
    staticClass: "no-options"
  }, [_vm._v("No work areas")]) : _vm._e()], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "filter-item type-item"
  }, [_c('label', [_vm._v("Bucket")]), _vm._v(" "), _c('div', {
    staticClass: "custom-multiselect"
  }, [_c('div', {
    staticClass: "select-trigger",
    on: {
      "click": function($event) {
        return _vm.toggleHubBucketDropdown($event)
      }
    }
  }, [(_vm.hubAnalyticsFilters.selectedBuckets.length === 0) ? _c('span', {
    staticClass: "placeholder"
  }, [_vm._v("All Buckets")]) : _c('span', {
    staticClass: "selected-tokens",
    attrs: {
      "title": _vm.hubAnalyticsFilters.selectedBuckets.join(', ')
    }
  }, [_vm._v(_vm._s(_vm.hubAnalyticsFilters.selectedBuckets.join(', ')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), (_vm.showHubBucketDropdown) ? _c('div', {
    staticClass: "select-dropdown"
  }, [_vm._l((_vm.availableHubBuckets), function(b) {
    return _c('div', {
      key: 'hub-b-' + b,
      staticClass: "dropdown-option",
      on: {
        "click": function($event) {
          return _vm.toggleHubBucketSelection(b)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.hubAnalyticsFilters.selectedBuckets.includes(b)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "type-text"
    }, [_vm._v(_vm._s(b))])])
  }), _vm._v(" "), (!_vm.availableHubBuckets.length) ? _c('div', {
    staticClass: "no-options"
  }, [_vm._v("No buckets")]) : _vm._e()], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "filter-item action-item"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-export",
    on: {
      "click": _vm.exportHubAnalyticsCSV
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export Hub Report\n            ")])])]) : (_vm.globalViewMode === 'geographic') ? _c('div', {
    staticClass: "filter-group"
  }, [_c('div', {
    staticClass: "filter-item date-item"
  }, [_c('label', [_vm._v("From Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "format": "DD-MM-YYYY",
      "type": "date",
      "placeholder": "Select From Date"
    },
    model: {
      value: (_vm.geoFilters.fromDate),
      callback: function($$v) {
        _vm.$set(_vm.geoFilters, "fromDate", $$v)
      },
      expression: "geoFilters.fromDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-item date-item"
  }, [_c('label', [_vm._v("To Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "format": "DD-MM-YYYY",
      "type": "date",
      "placeholder": "Select To Date"
    },
    model: {
      value: (_vm.geoFilters.toDate),
      callback: function($$v) {
        _vm.$set(_vm.geoFilters, "toDate", $$v)
      },
      expression: "geoFilters.toDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-item action-item"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-export rayg",
    on: {
      "click": _vm.exportGeographicCSV
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Export Geographic Report\n            ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.globalViewMode !== 'geographic' && _vm.globalViewMode !== 'hubAnalytics'),
      expression: "globalViewMode !== 'geographic' && globalViewMode !== 'hubAnalytics'"
    }],
    staticClass: "pagination-header"
  }, [_c('div', {
    staticClass: "stats-container"
  }, [(_vm.globalViewMode === 'performance') ? _c('div', {
    staticClass: "stats-info"
  }, [_vm._v("Showing " + _vm._s(_vm.paginatedData.length) + " of " + _vm._s(_vm.filteredData.length) + " Employees")]) : _c('div', {
    staticClass: "stats-info"
  }, [_vm._v("Viewing " + _vm._s(_vm.filteredData.length) + " Employees")]), _vm._v(" "), (_vm.globalViewMode !== 'geographic' && _vm.summary && _vm.raygCounts) ? _c('div', {
    staticClass: "rayg-summary"
  }, [_c('div', {
    staticClass: "summary-pill all",
    class: {
      'active': _vm.activeFilters.status === null
    },
    on: {
      "click": function($event) {
        return _vm.toggleStatusFilter(null)
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("All Active")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.baseFilteredData.filter(function (e) { return e && e.aggregate && e.aggregate.totalScans > 0; }).length))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-pill critical",
    class: {
      'active': _vm.activeFilters.status === 'R'
    },
    on: {
      "click": function($event) {
        return _vm.toggleStatusFilter('R')
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("0-3 Hrs")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.raygCounts.R))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-pill warning",
    class: {
      'active': _vm.activeFilters.status === 'A'
    },
    on: {
      "click": function($event) {
        return _vm.toggleStatusFilter('A')
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("3-5 Hrs")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.raygCounts.A))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-pill good",
    class: {
      'active': _vm.activeFilters.status === 'Y'
    },
    on: {
      "click": function($event) {
        return _vm.toggleStatusFilter('Y')
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("5-7 Hrs")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.raygCounts.Y))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-pill excellent",
    class: {
      'active': _vm.activeFilters.status === 'G'
    },
    on: {
      "click": function($event) {
        return _vm.toggleStatusFilter('G')
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("7-8 Hrs")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.raygCounts.G))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-pill excellent-plus",
    class: {
      'active': _vm.activeFilters.status === 'B'
    },
    on: {
      "click": function($event) {
        return _vm.toggleStatusFilter('B')
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("8+ Hrs")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.raygCounts.B))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-pill no-scan",
    class: {
      'active': _vm.activeFilters.status === 'N'
    },
    on: {
      "click": function($event) {
        return _vm.toggleStatusFilter('N')
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("No Scan")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.raygCounts.N || 0))])])]) : _vm._e()]), _vm._v(" "), (_vm.globalViewMode === 'performance') ? _c('div', {
    staticClass: "controls"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.currentPage === 1
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "page-info"
  }, [_vm._v("Page " + _vm._s(_vm.currentPage) + " of " + _vm._s(_vm.totalPages))]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.currentPage === _vm.totalPages
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])]) : _vm._e()]), _vm._v(" "), (_vm.globalViewMode === 'performance') ? _c('div', {
    staticClass: "employee-list"
  }, _vm._l((_vm.paginatedData), function(emp) {
    return _c('div', {
      key: emp.userId,
      staticClass: "emp-wrapper",
      class: {
        'is-expanded': _vm.isExpanded(emp.userId)
      }
    }, [_c('div', {
      staticClass: "emp-summary-row",
      class: _vm.getStatusClass(emp.aggregate.rayg),
      on: {
        "click": function($event) {
          return _vm.toggleExpand(emp.userId)
        }
      }
    }, [_c('div', {
      staticClass: "col-profile"
    }, [_c('div', {
      staticClass: "avatar-circle",
      class: _vm.getStatusClass(emp.aggregate.rayg)
    }, [_vm._v("\n                " + _vm._s(emp.employeeName.charAt(0)) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "name-row"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(emp.employeeName))]), _vm._v(" "), _c('span', {
      staticClass: "type-badge"
    }, [_vm._v(_vm._s(emp.workstream))])]), _vm._v(" "), _c('div', {
      staticClass: "meta-tags"
    }, [_c('span', {
      staticClass: "tag id"
    }, [_vm._v("ID: " + _vm._s(emp.employeeId))]), _vm._v(" "), (emp.empCode && emp.empCode !== emp.employeeId) ? _c('span', {
      staticClass: "tag code"
    }, [_vm._v(_vm._s(emp.empCode))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "col-timings"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isToday()),
        expression: "isToday()"
      }]
    }, [(_vm.perfFilters.days === 1) ? _c('div', {
      staticClass: "timing-pill"
    }, [_c('div', {
      staticClass: "time-box"
    }, [_c('label', [_vm._v("Login")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(emp.loginTime || '--:--'))])]), _vm._v(" "), _c('div', {
      staticClass: "time-box"
    }, [_c('label', [_vm._v("Punch")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(emp.punchTime || '--:--'))])]), _vm._v(" "), _c('div', {
      staticClass: "time-box"
    }, [_c('label', [_vm._v("Logout")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(emp.logoutTime || '--:--'))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-performance"
    }, [_c('div', {
      staticClass: "metric-item"
    }, [_c('label', [_vm._v("Expected")]), _vm._v(" "), _c('span', {
      staticClass: "val"
    }, [_vm._v(_vm._s(emp.aggregate.expectedTime) + " "), _c('small', [_vm._v("Hrs")])])]), _vm._v(" "), _c('div', {
      staticClass: "metric-item"
    }, [_c('label', [_vm._v("Actual")]), _vm._v(" "), _c('span', {
      staticClass: "val"
    }, [_vm._v(_vm._s(emp.aggregate.actualTime) + " "), _c('small', [_vm._v("Hrs")])])]), _vm._v(" "), _c('div', {
      staticClass: "metric-item highlight"
    }, [_c('label', [_vm._v("Idle Time")]), _vm._v(" "), _c('span', {
      staticClass: "val"
    }, [_vm._v(_vm._s(emp.aggregate.idealTime) + " "), _c('small', [_vm._v("Hrs")])])]), _vm._v(" "), _c('div', {
      staticClass: "metric-item"
    }, [_c('label', [_vm._v("Output")]), _vm._v(" "), _c('span', {
      staticClass: "val"
    }, [_vm._v(_vm._s(emp.aggregate.totalScans) + " "), _c('small', [_vm._v("Scans")])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-status"
    }, [_c('div', {
      staticClass: "status-indicator",
      class: _vm.getStatusClass(emp.aggregate.rayg)
    }, [_c('span', {
      staticClass: "dot"
    }), _vm._v("\n                " + _vm._s(_vm.getStatusLabel(emp.aggregate.rayg)) + "\n              ")]), _vm._v(" "), _c('i', {
      staticClass: "fa chevron",
      class: _vm.isExpanded(emp.userId) ? 'fa-chevron-up' : 'fa-chevron-down'
    })])]), _vm._v(" "), (_vm.isExpanded(emp.userId)) ? _c('div', {
      staticClass: "emp-expanded-matrix"
    }, [_c('div', {
      staticClass: "matrix-header"
    }, [_c('div', {
      staticClass: "header-left"
    }, [_c('h3', [_vm._v(_vm._s(_vm.perfFilters.days === 1 ? 'Hourly Activity Breakdown' : 'Daily Performance Trend'))])]), _vm._v(" "), _c('button', {
      staticClass: "btn-csv",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.exportPerformanceCSV.apply(null, arguments)
        }
      }
    }, [_vm._v("Download CSV")])]), _vm._v(" "), (_vm.perfFilters.days > 1) ? _c('div', {
      staticClass: "trend-chart-container"
    }, [_c('apexchart', {
      attrs: {
        "type": "bar",
        "height": "200",
        "options": _vm.getChartOptions(emp),
        "series": _vm.getChartSeries(emp)
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "matrix-scroll-wrapper"
    }, [_c('table', {
      staticClass: "work-matrix-table",
      class: _vm.viewMode
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "sticky-col first"
    }, [_vm._v("Main Work Area")]), _vm._v(" "), _c('th', {
      staticClass: "sticky-col second"
    }, [_vm._v("Activity (Bucket)")]), _vm._v(" "), (_vm.viewMode === 'matrix') ? _vm._l((24), function(h) {
      return _c('th', {
        key: h,
        staticClass: "hour-th"
      }, [_vm._v(_vm._s(h - 1) + "h")])
    }) : _vm._l((_vm.summaryDates), function(date) {
      return _c('th', {
        key: date,
        staticClass: "date-th"
      }, [_vm._v(_vm._s(date))])
    }), _vm._v(" "), _c('th', {
      staticClass: "total-th"
    }, [_vm._v("Total Scans")]), _vm._v(" "), _c('th', {
      staticClass: "mhr-th"
    }, [_vm._v("MHR")])], 2)]), _vm._v(" "), _c('tbody', [_vm._l((emp.categoryGroups), function(group) {
      return [_vm._l((group.buckets), function(bName, idx) {
        return _c('tr', {
          key: bName,
          staticClass: "bucket-row"
        }, [(idx === 0) ? _c('td', {
          staticClass: "main-cat-td sticky-col first",
          attrs: {
            "rowspan": group.buckets.length
          }
        }, [_vm._v("\n                      " + _vm._s(group.name) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "secondary-cat-td sticky-col second"
        }, [_vm._v("\n                      " + _vm._s(bName) + "\n                    ")]), _vm._v(" "), (_vm.viewMode === 'matrix') ? _vm._l((_vm.getBucketHourly(emp, bName)), function(val, hour) {
          return _c('td', {
            key: hour,
            staticClass: "val-td",
            class: {
              'has-work': val > 0
            }
          }, [_vm._v("\n                        " + _vm._s(val || '0') + "\n                      ")])
        }) : _vm._l((_vm.getBucketDaily(emp, bName)), function(val, dIdx) {
          return _c('td', {
            key: dIdx,
            staticClass: "val-td",
            class: {
              'has-work': val > 0
            }
          }, [_vm._v("\n                        " + _vm._s(val || '0') + "\n                      ")])
        }), _vm._v(" "), _c('td', {
          staticClass: "total-td"
        }, [_c('strong', [_vm._v(_vm._s(_vm.getBucketTotal(emp, bName)))])]), _vm._v(" "), _c('td', {
          staticClass: "mhr-td"
        }, [_c('strong', [_vm._v(_vm._s(_vm.getBucketMHR(emp, bName)))])])], 2)
      }), _vm._v(" "), _c('tr', {
        staticClass: "group-footer"
      }, [_c('td', {
        staticClass: "sticky-col both-sticky text-right",
        attrs: {
          "colspan": "2"
        }
      }, [_c('strong', [_vm._v(_vm._s(group.name) + " Total")])]), _vm._v(" "), (_vm.viewMode === 'matrix') ? _vm._l((group.hourlyTotal), function(val, hour) {
        return _c('td', {
          key: hour,
          staticClass: "group-val-td"
        }, [_vm._v(_vm._s(val || '0'))])
      }) : _vm._l((_vm.getGroupDailyTotal(emp, group.name)), function(val, dIdx) {
        return _c('td', {
          key: dIdx,
          staticClass: "group-val-td"
        }, [_vm._v(_vm._s(val || '0'))])
      }), _vm._v(" "), _c('td', {
        staticClass: "group-total-td"
      }, [_c('strong', [_vm._v(_vm._s(group.totalScans))])]), _vm._v(" "), _c('td', {
        staticClass: "group-mhr-td"
      }, [_c('strong', [_vm._v(_vm._s(_vm.getGroupMHR(emp, group.name)))])])], 2)]
    }), _vm._v(" "), _c('tr', {
      staticClass: "overall-total-row"
    }, [_c('td', {
      staticClass: "sticky-col both-sticky",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("OVERALL SHIFT TOTAL")]), _vm._v(" "), (_vm.viewMode === 'matrix') ? _vm._l((emp.aggregate.hourlyScans), function(val, hour) {
      return _c('td', {
        key: hour,
        staticClass: "overall-val-td"
      }, [_vm._v(_vm._s(val || '0'))])
    }) : _vm._l((_vm.getGroupDailyTotal(emp, 'ALL')), function(val, dIdx) {
      return _c('td', {
        key: dIdx,
        staticClass: "overall-val-td"
      }, [_vm._v("\n                      " + _vm._s(emp.buckets.reduce(function (acc, b) { return acc + (b.dailyBreakdown[dIdx] || 0); }, 0).toFixed(2)) + "\n                    ")])
    }), _vm._v(" "), _c('td', {
      staticClass: "overall-total-td"
    }, [_vm._v(_vm._s(emp.aggregate.totalScans))]), _vm._v(" "), _c('td', {
      staticClass: "overall-mhr-td"
    }, [_vm._v(_vm._s(emp.aggregate.totalMHR || (emp.aggregate.totalScans / 250).toFixed(2)))])], 2)], 2)])])]) : _vm._e()])
  }), 0) : (_vm.globalViewMode === 'rayg') ? _c('div', {
    staticClass: "rayg-grid-view animated fadeIn"
  }, [_c('div', {
    staticClass: "grid-card"
  }, [_c('div', {
    staticClass: "grid-header"
  }, [_c('div', {
    staticClass: "title-section"
  }, [_c('h3', [_vm._v("Operational Health Grid (RAYG)")]), _vm._v(" "), _c('span', {
    staticClass: "grid-date-range"
  }, [_vm._v(_vm._s(_vm.raygFilters.days === 1 ? _vm.moment(_vm.raygFilters.date).format('DD-MM-YYYY') : _vm.moment(_vm.raygFilters.date).subtract(_vm.raygFilters.days - 1, 'days').format('DD-MM-YYYY') + ' to ' + _vm.moment(_vm.raygFilters.date).format('DD-MM-YYYY')))])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, _vm._l((_vm.getLegendItems()), function(item) {
    return _c('span', {
      key: item.id,
      staticClass: "l-item",
      class: item.id
    }, [_vm._v("\n              " + _vm._s(item.label) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "grid-scroll-wrapper"
  }, [_c('table', {
    staticClass: "rayg-matrix",
    class: _vm.viewMode
  }, [_c('thead', [_c('tr', {
    staticClass: "header-main"
  }, [_c('th', {
    staticClass: "sticky-col emp-info-th"
  }, [_vm._v("Employee Information")]), _vm._v(" "), (_vm.viewMode === 'matrix') ? _vm._l((24), function(h) {
    return _c('th', {
      key: h,
      staticClass: "rayg-cell-th"
    }, [_c('div', {
      staticClass: "date-header-wrapper"
    }, [_c('span', {
      staticClass: "date-num"
    }, [_vm._v(_vm._s(h - 1))]), _vm._v(" "), _c('span', {
      staticClass: "date-day"
    }, [_vm._v("hrs")])])])
  }) : _vm._l((_vm.summaryDates), function(date) {
    return _c('th', {
      key: date,
      staticClass: "rayg-cell-th"
    }, [_c('div', {
      staticClass: "date-header-wrapper"
    }, [_c('span', {
      staticClass: "date-num"
    }, [_vm._v(_vm._s(date.split(' ')[0]))]), _vm._v(" "), _c('span', {
      staticClass: "date-day"
    }, [_vm._v(_vm._s(date.split(' ')[1] ? date.split(' ')[1].replace('(', '').replace(')', '') : ''))])])])
  })], 2), _vm._v(" "), _vm._l((_vm.getStatusRows()), function(status) {
    return _c('tr', {
      key: 'top-' + status.id,
      staticClass: "stats-row top",
      class: status.id
    }, [_c('td', {
      staticClass: "sticky-col text-right"
    }, [_vm._v(_vm._s(status.label))]), _vm._v(" "), (_vm.viewMode === 'matrix') ? _vm._l((24), function(hour) {
      return _c('td', {
        key: 'sh-' + hour
      }, [_vm._v("\n                    " + _vm._s(_vm.getColumnStatusCount(hour - 1, status.id)) + "\n                  ")])
    }) : _vm._l((_vm.summaryDates), function(date, dIdx) {
      return _c('td', {
        key: 'sd-' + dIdx
      }, [_vm._v("\n                    " + _vm._s(_vm.getColumnStatusCount(dIdx, status.id)) + "\n                  ")])
    })], 2)
  }), _vm._v(" "), _c('tr', {
    staticClass: "spacer-row"
  }, [_c('td', {
    staticClass: "sticky-col"
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": _vm.viewMode === 'matrix' ? 24 : _vm.summaryDates.length
    }
  })])], 2), _vm._v(" "), _c('tbody', [_vm._l((_vm.filteredData), function(emp) {
    return _c('tr', {
      key: emp.userId
    }, [_c('td', {
      staticClass: "sticky-col"
    }, [_c('div', {
      staticClass: "e-info-expanded"
    }, [_c('div', {
      staticClass: "top-row"
    }, [_c('span', {
      staticClass: "name",
      attrs: {
        "title": emp.employeeName
      }
    }, [_vm._v(_vm._s(emp.employeeName))]), _vm._v(" "), _c('span', {
      staticClass: "type-badge"
    }, [_vm._v(_vm._s(emp.workstream))])]), _vm._v(" "), _c('div', {
      staticClass: "bot-row"
    }, [_c('span', {
      staticClass: "id"
    }, [_vm._v("ID: " + _vm._s(emp.employeeId))]), _vm._v(" "), (emp.empCode || emp.email) ? _c('span', {
      staticClass: "email",
      attrs: {
        "title": emp.empCode || emp.email
      }
    }, [_vm._v("• " + _vm._s(emp.empCode || emp.email))]) : _vm._e()])])]), _vm._v(" "), (_vm.viewMode === 'matrix') ? _vm._l((24), function(hour) {
      return _c('td', {
        key: 'h-' + hour,
        staticClass: "rayg-cell",
        class: _vm.getRaygClass(emp, hour - 1)
      }, [_vm._v("\n                    " + _vm._s(_vm.getAggregateMHR(emp, hour - 1)) + "\n                  ")])
    }) : _vm._l((_vm.summaryDates), function(date, dIdx) {
      return _c('td', {
        key: 'd-' + dIdx,
        staticClass: "rayg-cell",
        class: _vm.getRaygClass(emp, dIdx)
      }, [_vm._v("\n                    " + _vm._s(_vm.getAggregateMHR(emp, dIdx)) + "\n                  ")])
    })], 2)
  }), _vm._v(" "), _c('tr', {
    staticClass: "spacer-row"
  }, [_c('td', {
    staticClass: "sticky-col"
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": _vm.viewMode === 'matrix' ? 24 : _vm.summaryDates.length
    }
  })])], 2), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "final-total-row mhr"
  }, [_c('td', {
    staticClass: "sticky-col text-right"
  }, [_vm._v("Total Man Hours (MHR)")]), _vm._v(" "), (_vm.viewMode === 'matrix') ? _vm._l((24), function(hour) {
    return _c('td', {
      key: hour
    }, [_vm._v(_vm._s(_vm.getColumnTotalMHR(hour - 1)))])
  }) : _vm._l((_vm.summaryDates), function(date, dIdx) {
    return _c('td', {
      key: dIdx
    }, [_vm._v(_vm._s(_vm.getColumnTotalMHR(dIdx)))])
  })], 2), _vm._v(" "), _c('tr', {
    staticClass: "final-total-row mandays"
  }, [_c('td', {
    staticClass: "sticky-col text-right"
  }, [_vm._v("Total Mandays (8h)")]), _vm._v(" "), (_vm.viewMode === 'matrix') ? _vm._l((24), function(hour) {
    return _c('td', {
      key: hour
    }, [_vm._v(_vm._s((_vm.getColumnTotalMHR(hour - 1) / 8).toFixed(2)))])
  }) : _vm._l((_vm.summaryDates), function(date, dIdx) {
    return _c('td', {
      key: dIdx
    }, [_vm._v(_vm._s((_vm.getColumnTotalMHR(dIdx) / 8).toFixed(2)))])
  })], 2)])])])])]) : (_vm.globalViewMode === 'hubAnalytics') ? _c('div', {
    staticClass: "hub-analytics-view animated fadeIn"
  }, [(_vm.hubAnalyticsData.length) ? _c('div', {
    staticClass: "hub-analytics-content"
  }, [(_vm.hubBucketFilterActive) ? _c('div', {
    staticClass: "hub-filter-chips"
  }, [_c('span', {
    staticClass: "chip-label"
  }, [_vm._v("Scoped to")]), _vm._v(" "), _vm._l((_vm.hubAnalyticsFilters.selectedCategories), function(cat) {
    return _c('span', {
      key: 'chip-c-' + cat,
      staticClass: "filter-chip",
      on: {
        "click": function($event) {
          return _vm.toggleHubCategorySelection(cat)
        }
      }
    }, [_vm._v("\n            " + _vm._s(cat) + " "), _c('i', {
      staticClass: "fa fa-times"
    })])
  }), _vm._v(" "), _vm._l((_vm.hubAnalyticsFilters.selectedBuckets), function(b) {
    return _c('span', {
      key: 'chip-b-' + b,
      staticClass: "filter-chip bucket",
      on: {
        "click": function($event) {
          return _vm.toggleHubBucketSelection(b)
        }
      }
    }, [_vm._v("\n            " + _vm._s(b) + " "), _c('i', {
      staticClass: "fa fa-times"
    })])
  }), _vm._v(" "), _c('button', {
    staticClass: "chip-clear",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearHubBucketFilters
    }
  }, [_vm._v("Clear bucket filters")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hub-kpi-grid"
  }, [_c('div', {
    staticClass: "kpi-card highlight"
  }, [_c('span', {
    staticClass: "kpi-label"
  }, [_vm._v("Hub performance score")]), _vm._v(" "), _c('span', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.hubAnalyticsSummary.hubPerformanceScore)), _c('small', [_vm._v("%")])]), _vm._v(" "), _c('span', {
    staticClass: "kpi-hint"
  }, [_vm._v("MHR vs " + _vm._s(_vm.hubAnalyticsSummary.activeCount) + " × 8h × " + _vm._s(_vm.hubAnalyticsFilters.days) + "d")])]), _vm._v(" "), _c('div', {
    staticClass: "kpi-card"
  }, [_c('span', {
    staticClass: "kpi-label"
  }, [_vm._v("Total scans")]), _vm._v(" "), _c('span', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.hubAnalyticsSummary.totalScans.toLocaleString()))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-hint"
  }, [_vm._v(_vm._s(_vm.hubAnalyticsSummary.periodLabel) + _vm._s(_vm.hubBucketFilterActive ? ' · filtered' : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "kpi-card"
  }, [_c('span', {
    staticClass: "kpi-label"
  }, [_vm._v("Total MHR")]), _vm._v(" "), _c('span', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.hubAnalyticsSummary.totalMHR))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-hint"
  }, [_vm._v("Earned man-hours")])]), _vm._v(" "), _c('div', {
    staticClass: "kpi-card"
  }, [_c('span', {
    staticClass: "kpi-label"
  }, [_vm._v("Roster utilization")]), _vm._v(" "), _c('span', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.hubAnalyticsSummary.utilizationPct)), _c('small', [_vm._v("%")])]), _vm._v(" "), _c('span', {
    staticClass: "kpi-hint"
  }, [_vm._v(_vm._s(_vm.hubAnalyticsSummary.activeCount) + " / " + _vm._s(_vm.hubAnalyticsSummary.rosterCount) + " active")])]), _vm._v(" "), _c('div', {
    staticClass: "kpi-card"
  }, [_c('span', {
    staticClass: "kpi-label"
  }, [_vm._v("Avg MHR / active")]), _vm._v(" "), _c('span', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.hubAnalyticsSummary.avgMhrPerActive))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-hint"
  }, [_vm._v("Per scanning employee")])]), _vm._v(" "), _c('div', {
    staticClass: "kpi-card"
  }, [_c('span', {
    staticClass: "kpi-label"
  }, [_vm._v("Avg productivity index")]), _vm._v(" "), _c('span', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.hubAnalyticsSummary.avgProdIndex))]), _vm._v(" "), _c('span', {
    staticClass: "kpi-hint"
  }, [_vm._v("Active workforce average")])]), _vm._v(" "), (_vm.hubAnalyticsSummary.peakHour !== null) ? _c('div', {
    staticClass: "kpi-card"
  }, [_c('span', {
    staticClass: "kpi-label"
  }, [_vm._v("Peak scan hour")]), _vm._v(" "), _c('span', {
    staticClass: "kpi-value"
  }, [_vm._v(_vm._s(_vm.hubAnalyticsSummary.peakHour) + ":00")]), _vm._v(" "), _c('span', {
    staticClass: "kpi-hint"
  }, [_vm._v("Highest throughput in scope")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "hub-charts-row"
  }, [_c('div', {
    staticClass: "chart-card wide"
  }, [_c('h3', [_vm._v("Hub hourly throughput")]), _vm._v(" "), _c('p', {
    staticClass: "chart-sub"
  }, [_vm._v("\n              " + _vm._s(_vm.hubBucketFilterActive ? 'Hourly scans for selected work area / buckets' : 'Aggregated scans across all buckets') + "\n              · solid orange = selected day · dotted = last 7-day avg · blue = same weekday (" + _vm._s(_vm.hubCompareMeta.weeksAgo || 1) + "w ago)\n              (" + _vm._s(_vm.hubCompareMeta.lastWeekLabel || 'prior week') + ")\n            ")]), _vm._v(" "), (_vm.hubAnalyticsSummary.totalScans > 0 || _vm.hubHourlyCompareSeries.last7Avg.some(function (v) { return v > 0; }) || _vm.hubHourlyCompareSeries.lastWeekSameDay.some(function (v) { return v > 0; })) ? _c('apexchart', {
    attrs: {
      "type": "line",
      "height": "300",
      "options": _vm.hubHourlyChartOptions,
      "series": _vm.hubHourlyChartSeries
    }
  }) : _c('p', {
    staticClass: "chart-sub"
  }, [_vm._v("No scan volume for this filter.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-card"
  }, [_c('h3', [_vm._v("Workforce RAYG mix")]), _vm._v(" "), _c('p', {
    staticClass: "chart-sub"
  }, [_vm._v(_vm._s(_vm.hubBucketFilterActive ? 'Based on filtered bucket MHR' : 'Distribution by earned MHR band'))]), _vm._v(" "), (_vm.hubAnalyticsSummary.rosterCount > 0) ? _c('apexchart', {
    attrs: {
      "type": "donut",
      "height": "300",
      "options": _vm.hubRaygChartOptions,
      "series": _vm.hubRaygChartSeries
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.hubAnalyticsSummary.workstreams.length) ? _c('div', {
    staticClass: "hub-charts-row"
  }, [_c('div', {
    staticClass: "chart-card wide"
  }, [_c('h3', [_vm._v("Top workstreams by volume")]), _vm._v(" "), _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "280",
      "options": _vm.hubWorkstreamChartOptions,
      "series": _vm.hubWorkstreamChartSeries
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hub-tables-row"
  }, [_c('div', {
    staticClass: "table-card"
  }, [_c('h3', [_vm._v("Workstream performance")]), _vm._v(" "), _c('table', {
    staticClass: "hub-metrics-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.hubAnalyticsSummary.workstreams), function(row) {
    return _c('tr', {
      key: row.workstream
    }, [_c('td', [_vm._v(_vm._s(row.workstream))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.employees))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.active))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.scans.toLocaleString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.mhr.toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.active ? (row.mhr / row.active).toFixed(2) : '—'))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "table-card"
  }, [_vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "hub-metrics-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.hubAnalyticsSummary.categories), function(row) {
    return _c('tr', {
      key: row.category,
      staticClass: "clickable-row",
      class: {
        active: _vm.hubAnalyticsFilters.selectedCategories.length === 1 && _vm.hubAnalyticsFilters.selectedCategories[0] === row.category
      },
      on: {
        "click": function($event) {
          return _vm.setHubCategoryFilter(row.category)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(row.category))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.scans.toLocaleString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.mhr.toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.hubAnalyticsSummary.totalScans ? Math.round((row.scans / _vm.hubAnalyticsSummary.totalScans) * 100) : 0) + "%")])])
  }), 0)])])]), _vm._v(" "), (_vm.hubAnalyticsSummary.buckets.length) ? _c('div', {
    staticClass: "table-card hub-bucket-hourly"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "bucket-hourly-scroll"
  }, [_c('table', {
    staticClass: "hub-metrics-table bucket-hour-matrix"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "sticky-bucket"
  }, [_vm._v("Bucket")]), _vm._v(" "), _c('th', [_vm._v("Area")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("MHR")]), _vm._v(" "), _vm._l((24), function(h) {
    return _c('th', {
      key: 'bh-' + h
    }, [_vm._v(_vm._s(h - 1))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.hubAnalyticsSummary.buckets), function(row) {
    return _c('tr', {
      key: row.bucketName,
      staticClass: "clickable-row",
      class: {
        active: _vm.hubAnalyticsFilters.selectedBuckets.length === 1 && _vm.hubAnalyticsFilters.selectedBuckets[0] === row.bucketName
      },
      on: {
        "click": function($event) {
          return _vm.setHubBucketFilter(row.bucketName)
        }
      }
    }, [_c('td', {
      staticClass: "sticky-bucket"
    }, [_vm._v(_vm._s(row.bucketName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.category))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.scans.toLocaleString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.mhr.toFixed(2)))]), _vm._v(" "), _vm._l((row.hourly), function(val, hi) {
      return _c('td', {
        key: row.bucketName + '-' + hi,
        class: {
          'has-vol': val > 0
        }
      }, [_vm._v(_vm._s(val || ''))])
    })], 2)
  }), 0)])])]) : _vm._e()]) : (!_vm.isLoading) ? _c('div', {
    staticClass: "no-results hub-empty"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" "), _c('p', [_vm._v("No hub data for the selected period. Try another date or hub.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.totalPages > 1 && _vm.globalViewMode === 'performance') ? _c('div', {
    staticClass: "pagination-footer"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.currentPage === 1
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Previous")]), _vm._v(" "), _c('span', {
    staticClass: "page-info"
  }, [_vm._v("Page " + _vm._s(_vm.currentPage) + " of " + _vm._s(_vm.totalPages))]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.currentPage === _vm.totalPages
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "fa fa-chevron-right"
  })])]) : _vm._e(), _vm._v(" "), (_vm.globalViewMode === 'geographic') ? _c('div', {
    staticClass: "geo-empty-state text-center",
    staticStyle: {
      "padding": "60px 20px",
      "color": "#6c757d"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-o",
    staticStyle: {
      "font-size": "48px",
      "margin-bottom": "15px",
      "color": "#d1d8e0"
    }
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-weight": "500",
      "font-size": "20px",
      "color": "#2d3436",
      "margin-bottom": "8px"
    }
  }, [_vm._v("Geographic Export Mode")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Use the filters above to export Zonal, State, or City-wide productivity reports.")])]) : (_vm.globalViewMode !== 'hubAnalytics' && _vm.globalViewMode !== 'geographic' && !_vm.filteredData.length && !_vm.isLoading) ? _c('div', {
    staticClass: "no-results"
  }, [_c('i', {
    staticClass: "fa fa-user-times"
  }), _vm._v(" "), _c('p', [_vm._v("No results match your filters.")])]) : _vm._e()], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Workstream")]), _vm._v(" "), _c('th', [_vm._v("Roster")]), _vm._v(" "), _c('th', [_vm._v("Active")]), _vm._v(" "), _c('th', [_vm._v("Scans")]), _vm._v(" "), _c('th', [_vm._v("MHR")]), _vm._v(" "), _c('th', [_vm._v("Avg MHR / active")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Work category breakdown "), _c('small', [_vm._v("click to filter")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Category")]), _vm._v(" "), _c('th', [_vm._v("Scans")]), _vm._v(" "), _c('th', [_vm._v("MHR")]), _vm._v(" "), _c('th', [_vm._v("% of hub scans")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bucket-hourly-header"
  }, [_c('div', [_c('h3', [_vm._v("Bucket hourly insight")]), _vm._v(" "), _c('p', {
    staticClass: "chart-sub"
  }, [_vm._v("Click a bucket to scope KPIs & hourly chart · values are scans per hour")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4329749a","hasScoped":true}!./src/views/components/ProductivityTracking/ProductivityTracking.html
// module id = 2059
// module chunks = 2